<template>
  <div class="relative" :class="[open && openWrapperClass, !open && closedWrapperClass]">
    <button
      type="button"
      :aria-expanded="open"
      aria-haspopup="true"
      class="w-full flex justify-between items-center focus:outline-none"
      :class="[buttonClass, open && openButtonClass]"
      @click="toggle"
    >
      <span class="flex-1 min-w-0">
        <slot name="button">
          {{ label }}
        </slot>
      </span>
      <slot name="icon">
        <component :is="chevronIcon" size="1.5x" class="ml-4 flex-shrink-0" />
      </slot>
    </button>

    <div v-show="open" :class="contentClass">
      <slot />
    </div>
  </div>
</template>

<script>
import {
  ChevronUpIcon,
  ChevronDownIcon
} from '@bit/vekenkaluste.veke-ui.icons'

export default {
  name: 'Dropdown',
  components: {
    ChevronUpIcon,
    ChevronDownIcon
  },
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    closedWrapperClass: {
      type: [Object, Array, String],
      required: false,
      default: ''
    },
    openWrapperClass: {
      type: [Object, Array, String],
      required: false,
      default: ''
    },
    buttonClass: {
      type: [Object, Array, String],
      required: false,
      default: ''
    },
    openButtonClass: {
      type: [Object, Array, String],
      required: false,
      default: ''
    },
    contentClass: {
      type: [Object, Array, String],
      required: false,
      default: ''
    },
    transition: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['dropdown-toggle'],
  data () {
    return {
      open: false
    }
  },
  computed: {
    chevronIcon () {
      return this.open ? 'chevron-up-icon' : 'chevron-down-icon'
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
      this.$emit('dropdown-toggle', this.open)
    }
  }
}
</script>
